import Data from '../Api/Data'
import PrimaryKey from '../Api/PrimaryKey'
import { Type } from 'class-transformer'
import TLanguageTextTranslationDM from './TLanguageTextTranslationDM'

export default class TPeriodListDM extends Data {
	public static className = 'TPeriodListDM'
	public static primaryKey = 'Id'
	public static systemFields = [
		'TimeStamp',
	]

	public getPrimaryKey(): PrimaryKey {
		return this.Id!
	}

	TimeStamp?: string
	Name?: string
	EndDate?: Date
	Id?: number
	SelectionImgCalc?: string
	LegislationContextCalc?: number
	CurrentDateCalc?: Date
	CurrentTimeCalc?: Date
	StartDateCalc?: Date
	PresentationDateCalc?: Date
	LanguageTextCalc?: string
	@Type(() => TLanguageTextTranslationDM)
	LanguageNameChild?: TLanguageTextTranslationDM[]
}